<template>
  <v-form @submit.prevent="saveProposal()" v-model="valid" ref="form">
    <v-row>
      <v-col md="7">
        <v-card>
          <v-card-title>Add Proposal</v-card-title>
          <v-card-text>
            <v-text-field
              label="Proposal title"
              outlined
              placeholder="Title..."
              v-model="proposal.title"
              :rules="requiredRules"
            ></v-text-field>
            <h3 class="subtitle">Items</h3>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Title</th>
                    <th class="text-left">Description</th>
                    <th class="text-right">Value</th>
                    <th class="text-right">State</th>
                  </tr>
                </thead>
                <tbody v-if="proposal.items">
                  <tr v-for="(item, index) in proposal.items" :key="index">
                    <td>{{ item.title }}</td>
                    <td>{{ item.description }}</td>
                    <td class="text-right">{{ item.value }}€</td>
                    <td class="text-right">
                      <v-radio-group dense v-model="item.state" row>
                        <v-spacer></v-spacer>
                        <v-radio value="approved" label="Approved"></v-radio>
                        <v-radio value="rejected" label="Rejected"></v-radio>
                      </v-radio-group>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row dense class="my-4">
              <v-col md="6">
                <v-text-field
                  hide-details
                  label="Item"
                  outlined
                  placeholder="Item..."
                  v-model="newTitle"
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6">
                <v-text-field
                  hide-details
                  label="Value"
                  outlined
                  placeholder="Value..."
                  v-model="newValue"
                  dense
                  append-outer-icon="mdi-currency-eur"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <v-textarea
                  hide-details
                  label="Description"
                  outlined
                  placeholder="Description..."
                  v-model="newDescription"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-radio-group v-model="newState">
                  <v-radio value="approved" label="Approved"></v-radio>
                  <v-radio value="rejected" label="Rejected"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <v-btn @click="addItem()">Add item</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="5">
        <v-card class="mb-5">
          <v-card-title>Client</v-card-title>
          <v-card-text>
            <v-autocomplete
              :rules="requiredRules"
              v-model="proposal.client"
              :items="getClients"
              outlined
              chips
              label="Client"
              item-text="name"
              item-value="id"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="remove(data.item)"
                >{{ data.item.name }}</v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-avatar
                    color="indigo"
                    class="headline font-weight-light white--text"
                  >{{ data.item.name.charAt(0) }}</v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-card-text>
        </v-card>
        <v-card class="mb-5">
          <v-card-title>State</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item-group v-model="currentState" color="primary">
                <v-list-item v-for="(state, i) in states" :key="i">
                  <v-list-item-content>
                    <v-list-item-title v-text="state.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-list-item-action-text v-text="state.date"></v-list-item-action-text>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card class="mb-5">
          <v-card-title>Summary</v-card-title>
          <v-card-text>
            <v-list subheader>
              <v-subheader>Totals</v-subheader>
              <v-list-item v-if="proposal.items.length > 0">
                <v-list-item-avatar>
                  <v-icon>mdi-currency-eur</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Proposed</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>{{ totalProposto }}</v-list-item-icon>
              </v-list-item>
              <v-list-item v-if="proposal.items.length > 0">
                <v-list-item-avatar>
                  <v-icon>mdi-currency-eur</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Approved</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>{{ totalAprovado }}</v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>Payments</v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-right">Value</th>
                  </tr>
                </thead>
                <tbody v-if="proposal.payments">
                  <tr v-for="(item, index) in proposal.payments" :key="index">
                    <td>{{ item.date }}</td>
                    <td class="text-right">{{ item.value }}€</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider class="mb-3"></v-divider>
            <v-row>
              <v-col>
                <v-menu
                  v-model="newPaymentDateShow"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      v-model="newPaymentDate"
                      label="Payment day"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="newPaymentDate" @input="newPaymentDateShow = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="d-flex">
                <v-text-field
                  dense
                  v-model="newPaymentValue"
                  label="Payment Value"
                  append-icon="mdi-currency-eur"
                  outlined
                ></v-text-field>
                <v-btn class="ml-2" fab small @click="addPayment()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data: () => ({
    states: [
      {
        name: "Pending",
        date: "hoje"
      },
      {
        name: "Aproved",
        date: null
      },
      {
        name: "Invoice",
        date: null
      },
      {
        name: "Finished",
        date: null
      }
    ],
    currentState: 0,
    newPaymentDateShow: false,
    valid: true,
    requiredRules: [v => !!v || "Required"],
    proposal: {
      title: null,
      client: null,
      items: [],
      payments: []
    },
    newTitle: null,
    newDescription: null,
    newValue: null,
    newState: null,
    newPaymentDate: null,
    newPaymentValue: null
  }),
  computed: {
    ...mapGetters(["getClients"]),
    totalProposto() {
      let tempSum = 0;
      this.proposal.items.forEach(i => {
        tempSum += parseInt(i.value);
      });
      return tempSum;
    },
    totalAprovado() {
      let tempSum = 0;
      this.proposal.items.forEach(i => {
        if (i.state == "approved") tempSum += parseInt(i.value);
      });
      return tempSum;
    }
  },
  methods: {
    ...mapActions(["createProposal"]),
    addItem() {
      if (this.newTitle != null && this.newValue != null) {
        this.proposal.items.push({
          title: this.newTitle,
          description: this.newDescription,
          value: this.newValue,
          state: this.newState
        });
        this.newTitle = null;
        this.newDescription = null;
        this.newValue = null;
        this.newState = null;
      }
    },
    saveProposal() {
      if (!this.$refs.form.validate()) return;
      // se nao tivermos id é para criar, caso contrário é para actualizar
      if (!this.proposal.id) {
        this.proposal.currentState = this.currentState;
        // console.log(this.proposal);
        this.createProposal(this.proposal);
      }
    },
    addPayment() {
      if (this.newPaymentDate != null && this.newPaymentValue != null) {
        this.proposal.payments.push({
          date: this.newPaymentDate,
          value: this.newPaymentValue
        });
        this.newPaymentDate = null;
        this.newPaymentValue = null;
      }
    }
  }
};
</script>
